import api from './api';

interface DeleteAccountResponse {
  success: boolean;
  message: string;
}

class AccountService {
  /**
   * Permanently delete user account and all associated data
   * This will:
   * - Cancel any active Stripe subscription immediately
   * - Delete all projects, conversations, messages, and artifacts
   * - Delete the user account from Firebase Auth
   */
  async deleteAccount(): Promise<DeleteAccountResponse> {
    return await api.post<DeleteAccountResponse>('/api/account/delete');
  }
}

const accountService = new AccountService();
export default accountService;
